module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_row_3.a2681b44.png";